import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const InspectionDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  //GROUP_ASSET_DETAILS: 'Asset Details',
  GROUP_COLUMNS: 'Columns',
  SITE: 'Site',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PART: 'Part',
  CATEGORY: 'Category',
  MANUFACTURER: 'Manufacturer',
  RUL_START_DATE: 'RulStartDate',
  P90: 'p90',
};

// Completed work table configuration
export const inspectionDamagesColumnsDefs = {
  [InspectionDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [InspectionDamagesColumns.SITE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.site',
            a11yDefault: 'Site',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.RUL_START_DATE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_start_date',
            a11yDefault: 'RUL Start Date',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InspectionDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.p90',
            a11yDefault: 'P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const inspectionDamagesColumnsDefaultCols = [
  {
    id: InspectionDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: InspectionDamagesColumns.SITE,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.MODEL,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.PART,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: InspectionDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InspectionDamagesColumns.RUL_START_DATE,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InspectionDamagesColumns.P90,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
